import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DeviceLogsService {

  constructor(private http: HttpClient) {}

  getDeviceLogs(serialNumber: string, startDate: string, endDate: string): Observable<any> {

    const url = `${environment.host}/logs/${serialNumber}?startDate=${startDate}&endDate=${endDate}`;
  
    return this.http.get(url);
  }

  viewLogContent(filePath:string){
    const url = `${environment.host}/logs/content?filePath=${filePath}`;
    return this.http.get(url);
  }

  downloadLog(filePath: string) {
    const url = `${environment.host}/logs/download?filePath=${filePath}`;
    return this.http.get(url, { responseType: 'blob' });
  }  
}
